import { TbChartFunnel } from "react-icons/tb";

const getDataFieldsFunnelchart = () => {
  return [
    {
      title: "Name",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: Number,
    },
  ];
};

const getCustomizationFieldFunnelchart = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLegendVisible",
      innerComponents: [
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlign",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
          isParent: true,
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlign",
          options: [
            { label: "Top", value: "top" },
            { label: "Middle", value: "middle" },

            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "bottom" },
          isParent: true,
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayout",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
          isParent: true,
        },
      ],
    },
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelfunnelVisible",
      innerComponents: [


        {
          title: "Label Contents",
          type: "SELECT_BOX",
          reduxKey: "labelContents",
          options: [
            { label: "Category Name", value: "name" },
            { label: "Value", value: "value" },


          ],
          defaultValue: { label: "Category Name", value: "name" },
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFunnelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 12,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelFunnelFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },

      ],
    },
    //textbox
    {
      title: "Title",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isTileVisible",
      innerComponents: [
        {
          title: "Title",
          type: "text",
          defaultValue: "title...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "Title",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isTitleBold",
          isParent: true,
        },
        {
          title: "Title Color",
          type: "fontColor",
          reduxKey: "TitleFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Title Size",
          type: "range",
          defaultValue: 25,
          minValue: 8,
          maxValue: 30,
          reduxKey: "TitleSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },

        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },



      ],
    },
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelfunnelVisible",
      innerComponents: [
        {
          title: "Label Contents",
          type: "SELECT_BOX",
          reduxKey: "labelContents",
          options: [
            { label: "Category Name", value: "name" },
            { label: "Value", value: "value" },
          ],
          defaultValue: { label: "Category Name", value: "name" },
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFunnelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 12,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelFunnelFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },
    //textbox
    {
      title: "Title",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isTileVisible",
      innerComponents: [
        {
          title: "Title",
          type: "text",
          defaultValue: "title...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "Title",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isTitleBold",
          isParent: true,
        },
        {
          title: "Title Color",
          type: "fontColor",
          reduxKey: "TitleFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Title Size",
          type: "range",
          defaultValue: 25,
          minValue: 8,
          maxValue: 30,
          reduxKey: "TitleSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },

        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },
      ],
    },
  ];
};
const getFunnelChartDetails = () => {
  return {
    chartType: "echarts",
    imageSrc: "/graph_img/funnelchart.png",
    label: "Funnel",
    value: "funnelchart",
    icon: <TbChartFunnel className="text-xl text-blue-950" />,
    fileName: "FunnelChartComp.js",
  };
};
export {
  getDataFieldsFunnelchart,
  getCustomizationFieldFunnelchart,
  getFunnelChartDetails,
};
